import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"90vh"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "ofs RoomHistoryDetailModalScroll noscroll",
  style: {"height":"calc(90vh - 50px)"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"260px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "仲介メニュー")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_8 = {
  key: 0,
  class: "centered"
}
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "mb20" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "fl ml10 mt2" }, "別の公開ページに、提案を受けた日程を複製同期", -1)
const _hoisted_12 = {
  key: 0,
  class: "fl ml10"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = { class: "fs12 mt10" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "ml5" }, "提案型ページで利用することを想定しています", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "fl ml10 mt2" }, "別の公開ページに、提案を受けた日程を調整カレンダーとして設定", -1)
const _hoisted_19 = {
  key: 0,
  class: "fl ml10"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = { class: "fs12 mt10" }
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "ml5" }, "確定型ページで利用することを想定しています", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "fl ml10 mt4" }, "この調整カレンダーで確定した一覧を表示", -1)
const _hoisted_27 = {
  key: 0,
  class: "fl ml10"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = { class: "fs12 mt10" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "ml5" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = {
  key: 1,
  class: ""
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = { class: "" }
const _hoisted_38 = { class: "fl mt10" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_41 = { class: "mt40 pad10" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600" }, "公開ページを選択", -1)
const _hoisted_43 = { class: "fs14" }
const _hoisted_44 = {
  class: "mt10 mc",
  style: {"width":"320px"}
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = {
  key: 0,
  class: "fs11 fw600"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = { class: "w100" }
const _hoisted_50 = {
  key: 0,
  class: "w100 pad10"
}
const _hoisted_51 = ["src"]
const _hoisted_52 = {
  key: 0,
  class: "fl"
}
const _hoisted_53 = { class: "fs12" }
const _hoisted_54 = {
  key: 1,
  class: "fw600"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_57 = {
  key: 1,
  class: "w100 pad10"
}
const _hoisted_58 = ["src"]
const _hoisted_59 = {
  key: 0,
  class: "fl"
}
const _hoisted_60 = { class: "fs12" }
const _hoisted_61 = { class: "fw600" }
const _hoisted_62 = { class: "fs24 arial fw600" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_64 = {
  key: 1,
  class: "fs14"
}
const _hoisted_65 = {
  class: "mt10 mc",
  style: {"width":"320px"}
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_68 = { key: 1 }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_71 = {
  key: 2,
  class: ""
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"260px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "確認")
], -1)
const _hoisted_73 = {
  key: 0,
  class: "fr"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("p", { class: "fl" }, "  作成しています", -1)
const _hoisted_75 = {
  key: 3,
  class: ""
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {"width":"260px"}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "header_title fs24 centered",
    style: {"color":"#696969"}
  }, "完了")
], -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", null, "紐づけた先の公開ページを確認する", -1)
const _hoisted_78 = [
  _hoisted_76,
  _hoisted_77
]
const _hoisted_79 = { key: 1 }
const _hoisted_80 = { class: "w100 mb10" }
const _hoisted_81 = { class: "fl ml40 mt20" }
const _hoisted_82 = ["src"]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_84 = {
  class: "fl ofs w100",
  style: {"padding":"0 0 0 40px","height":"calc(90vh - 66px)"}
}
const _hoisted_85 = { class: "w100 pad40" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("p", { class: "fw600 fs16" }, "名前を変更", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("p", { class: "fs13" }, " IDを表示したり名前を変更することで、名前を公開することなくお相手に表示することができます。 ", -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_91 = { key: 2 }
const _hoisted_92 = { class: "w100 mb10" }
const _hoisted_93 = {
  key: 0,
  class: "fl ml40 mt20"
}
const _hoisted_94 = ["src"]
const _hoisted_95 = {
  key: 1,
  class: "fr ml40 mt20"
}
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_97 = {
  class: "fl ofs w100",
  style: {"padding":"0 0 0 40px","height":"calc(90vh - 66px)"}
}
const _hoisted_98 = { class: "w100 pad40" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("p", { class: "fw600 fs16" }, "表示する期間を変更", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_103 = {
  key: 3,
  class: "centered"
}
const _hoisted_104 = {
  key: 0,
  class: "fs24 fw600 centered",
  style: {"margin-top":"120px"}
}
const _hoisted_105 = { class: "fs20" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_107 = {
  key: 0,
  class: "mt20 mc",
  style: {"width":"360px"}
}
const _hoisted_108 = { class: "fs14 fw600" }
const _hoisted_109 = { class: "fl mt3" }
const _hoisted_110 = { class: "fs14" }
const _hoisted_111 = { class: "fs14" }
const _hoisted_112 = {
  key: 0,
  class: "lgreyBg fs12 pad5 ml15 rad5 fl"
}
const _hoisted_113 = ["src"]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_115 = ["onClick"]
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_120 = {
  key: 1,
  class: "fs24 fw600 centered",
  style: {"margin-top":"120px"}
}
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_IconLock = _resolveComponent("IconLock")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_AstagOpenScheduleSettings = _resolveComponent("AstagOpenScheduleSettings")!
  const _component_MdProgressSpinner = _resolveComponent("MdProgressSpinner")!
  const _component_SuggestedDatesPeriodSettings = _resolveComponent("SuggestedDatesPeriodSettings")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ChukaiMenuModal",
    "content-class": "rad10 with_white_bg shadowContent modalWide noscroll",
    onBeforeOpen: _ctx.openModal,
    onAfterClose: _ctx.closeModalFromComplete
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.viewType == `pub_room`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.step == 0)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", {
                            class: "fw600 circle_button blueAround pointer centered rad10 ml20 mr20 mt15",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyAstagForOtherRoom && _ctx.copyAstagForOtherRoom(...args)))
                          }, [
                            _hoisted_11,
                            (!_ctx.canUseChukaiMenu)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_component_IconLock, {
                                    style: {},
                                    class: "",
                                    width: 16
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_13
                          ]),
                          _createElementVNode("p", _hoisted_14, [
                            _withDirectives(_createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/hint_orange.png`),
                              width: "15",
                              class: ""
                            }, null, 8, _hoisted_15), [
                              [_directive_tooltip, `ヒント`]
                            ]),
                            _hoisted_16
                          ])
                        ]),
                        _hoisted_17,
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: "fw600 circle_button blueAround pointer centered rad10 ml20 mr20 mt15",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changePubRoomsAstag && _ctx.changePubRoomsAstag(...args)))
                          }, [
                            _hoisted_18,
                            (!_ctx.canUseChukaiMenu)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createVNode(_component_IconLock, {
                                    style: {},
                                    class: "",
                                    width: 16
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_20
                          ]),
                          _createElementVNode("p", _hoisted_21, [
                            _withDirectives(_createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/hint_orange.png`),
                              width: "15",
                              class: ""
                            }, null, 8, _hoisted_22), [
                              [_directive_tooltip, `ヒント`]
                            ]),
                            _hoisted_23
                          ])
                        ]),
                        _hoisted_24,
                        _createElementVNode("div", null, [
                          _createElementVNode("div", {
                            class: "fw600 circle_button blueAround pointer centered rad10 ml20 mr20 mt15",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeOpenSchedulesType && _ctx.changeOpenSchedulesType(...args)))
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/link.png`),
                              width: "20",
                              class: "fl mt3"
                            }, null, 8, _hoisted_25),
                            _hoisted_26,
                            (!_ctx.canUseChukaiMenu)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createVNode(_component_IconLock, {
                                    style: {},
                                    class: "",
                                    width: 16
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_28
                          ]),
                          _createElementVNode("p", _hoisted_29, [
                            _withDirectives(_createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/hint_orange.png`),
                              width: "15",
                              class: ""
                            }, null, 8, _hoisted_30), [
                              [_directive_tooltip, `ヒント`]
                            ]),
                            _createElementVNode("span", _hoisted_31, [
                              (_ctx.member.name)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.member.name) + "様が", 1))
                                : _createCommentVNode("", true),
                              _createTextVNode("確定した予定一覧を確認できるようにURLを発行します")
                            ])
                          ])
                        ]),
                        _hoisted_33
                      ]),
                      _hoisted_34
                    ]))
                  : (_ctx.step == 1)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", {
                              class: "pointer skyblue fs13",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.restart && _ctx.restart(...args)))
                            }, "< メニューに戻る")
                          ]),
                          ([`changeAstagForOtherPublicRoom`, `copyAstagForOtherPublicRoom`].includes(_ctx.createPlanType))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                (_ctx.selectedRoom)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "submit",
                                      class: "fr pointer centered circle_button skyblueBg fs14 rad8 mr20",
                                      style: {"height":"50px"},
                                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selectPubRoomEnd && _ctx.selectPubRoomEnd(...args)))
                                    }, _toDisplayString(_ctx.createPlanType == `changeAstagForOtherPublicRoom`
                                            ? `調整カレンダーを紐づけ`
                                            : `複製を実行する`), 1))
                                  : _createCommentVNode("", true),
                                _hoisted_40,
                                _createElementVNode("div", _hoisted_41, [
                                  _hoisted_42,
                                  _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.member.name) + "様が提案した日程を紐付ける公開ページのIDを入力してください。" + _toDisplayString(_ctx.member.name) + "様は今までの限定公開ページで引き続き何度でも提案ができます。 ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                  _createVNode(_component_MdTextfieldTag, {
                                    name: "公開ページIDを入力",
                                    fieldStyle: "min-width:250px;max-width:250px;",
                                    style: {"height":"56px","min-width":"250px"},
                                    class: "fs16 fl",
                                    value: _ctx.publicId,
                                    onInputValue: _ctx.inputPublicID,
                                    required: ""
                                  }, null, 8, ["value", "onInputValue"]),
                                  _createElementVNode("div", {
                                    class: "fl greyBg rad5 mt16 fs11 pointer hoverGreyBg",
                                    style: {"padding":"13px","height":"40px"},
                                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickConnectPublicRoom && _ctx.clickConnectPublicRoom(...args)))
                                  }, " 確認 "),
                                  _hoisted_45,
                                  (_ctx.selectedRoom)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, " 「" + _toDisplayString(`[${_ctx.selectedRoom.public_id}]${
                                                _ctx.selectedRoom.appeal_content.title
                                                    ? _ctx.selectedRoom.appeal_content.title
                                                    : _ctx.selectedRoom.current_appointment.name
                                            }`) + "」の公開ページで提案の同期を行います。 ", 1))
                                    : _createCommentVNode("", true),
                                  _hoisted_47
                                ]),
                                _hoisted_48,
                                _createElementVNode("div", _hoisted_49, [
                                  (_ctx.selectedRoom)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                        (_ctx.createPlanType == `copyAstagForOtherPublicRoom`)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(`w100 mt10 text-left pointer rad8`),
                                              style: {"border":"1px solid #dfdfdf","padding":"12px 0"},
                                              onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickChangeName && _ctx.clickChangeName(...args)), ["self"]))
                                            }, [
                                              _createElementVNode("img", {
                                                src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
                                                width: "26",
                                                height: "20",
                                                style: {"margin-top":"1px"},
                                                class: "fl mr2 ml10"
                                              }, null, 8, _hoisted_51),
                                              _createElementVNode("label", {
                                                class: "fl fs18 fw600 ddgrey text-left ml15 mt1 mr5 pointer",
                                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clickChangeName && _ctx.clickChangeName(...args)))
                                              }, "表示上の名前を変更 "),
                                              (_ctx.openMember)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                                    _createElementVNode("div", _hoisted_53, [
                                                      (_ctx.openMember.image_url)
                                                        ? (_openBlock(), _createBlock(_component_UserIcon, {
                                                            key: 0,
                                                            imageUrl: _ctx.openMember.image_url,
                                                            canEdit: false,
                                                            updateSelf: false,
                                                            width: 30,
                                                            class: "fl mr10",
                                                            style: {"margin-left":"-1px"}
                                                          }, null, 8, ["imageUrl"]))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.openMember.name)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                                                            _createElementVNode("span", null, _toDisplayString(_ctx.openMember.name), 1)
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      _createTextVNode("が公開ページで表示されます ")
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _hoisted_55
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _hoisted_56,
                                  (_ctx.selectedRoom)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                        (_ctx.createPlanType == `copyAstagForOtherPublicRoom`)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(`w100 mt10 text-left pointer rad8`),
                                              style: {"border":"1px solid #dfdfdf","padding":"12px 0"},
                                              onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clickChangeSpan && _ctx.clickChangeSpan(...args)), ["self"]))
                                            }, [
                                              _createElementVNode("img", {
                                                src: _ctx.$getAssetImageUrl(`/assets/icons/waaq_members.png`),
                                                width: "26",
                                                height: "20",
                                                style: {"margin-top":"1px"},
                                                class: "fl mr2 ml10"
                                              }, null, 8, _hoisted_58),
                                              _createElementVNode("label", {
                                                class: "fl fs18 fw600 ddgrey text-left ml15 mt1 mr5",
                                                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.clickChangeSpan && _ctx.clickChangeSpan(...args)))
                                              }, "表示する期間を変更 "),
                                              (_ctx.selectedLength)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                    _createElementVNode("div", _hoisted_60, [
                                                      _createElementVNode("span", _hoisted_61, [
                                                        _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.selectedLength), 1)
                                                      ]),
                                                      _createTextVNode("件が表示されます(後で変更可能) ")
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              _hoisted_63
                                            ]))
                                          : (_ctx.createPlanType == `changeAstagForOtherPublicRoom`)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                                _createElementVNode("div", _hoisted_65, [
                                                  _createVNode(_component_MdTextfieldTag, {
                                                    name: "公開ページ名を入力",
                                                    fieldStyle: "min-width:250px;max-width:250px;",
                                                    style: {"height":"56px","min-width":"250px"},
                                                    class: "fs16 fl",
                                                    value: _ctx.vrm.copyPubRoomTitle,
                                                    onInputValue: _ctx.inputCopyPubRoomTitle
                                                  }, null, 8, ["value", "onInputValue"]),
                                                  _hoisted_66
                                                ]),
                                                _createTextVNode(" 公開ページに紐づけた場合、公開ページの「編集」>「調整可能時間」により表示される日程が変わります。 "),
                                                _hoisted_67
                                              ]))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : (_ctx.createPlanType == `changeOpenSchedulesType`)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                  _hoisted_69,
                                  _createVNode(_component_AstagOpenScheduleSettings)
                                ]))
                              : _createCommentVNode("", true)
                        ]),
                        _hoisted_70
                      ]))
                    : (_ctx.step == 2)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_71, [
                          _hoisted_72,
                          _createElementVNode("div", null, _toDisplayString(_ctx.member.name) + "様が作成した調整カレンダーを" + _toDisplayString(_ctx.selectedPubRoom?.appeal_content?.title) + "に紐付けます。 ", 1),
                          (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                _createVNode(_component_MdProgressSpinner, {
                                  width: `30`,
                                  class: "fl",
                                  style: {"margin-top":"-8px"}
                                }),
                                _hoisted_74
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (_ctx.step == 3)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_75, _hoisted_78))
                        : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.viewType == `form`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                      width: "36",
                      height: "36",
                      class: "pointer",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.clickPreStepFromForm && _ctx.clickPreStepFromForm(...args)))
                    }, null, 8, _hoisted_82)
                  ]),
                  _hoisted_83
                ]),
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _hoisted_86,
                    _hoisted_87,
                    _createVNode(_component_MdTextfieldTag, {
                      name: "名前を入力",
                      fieldStyle: "min-width:250px;max-width:250px;",
                      style: {"height":"56px","min-width":"250px"},
                      class: "fs16 fl",
                      value: _ctx.openMember?.name,
                      onInputValue: _ctx.inputOpenMemberName
                    }, null, 8, ["value", "onInputValue"]),
                    _hoisted_88
                  ]),
                  _hoisted_89
                ]),
                _hoisted_90
              ]))
            : _createCommentVNode("", true),
          (_ctx.viewType == `period`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  (!_ctx.isOnlyPeriodPage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/arrow_left.png`),
                          width: "36",
                          height: "36",
                          class: "pointer",
                          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.clickPreStepFromPeriod && _ctx.clickPreStepFromPeriod(...args)))
                        }, null, 8, _hoisted_94)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isOnlyPeriodPage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "fr pointer centered circle_button skyblueBg fs14 rad8 mr20",
                          style: {"height":"50px"},
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.changeOnlyPeriod && _ctx.changeOnlyPeriod(...args)))
                        }, " 変更を保存 ")
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_96
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _hoisted_99,
                    _createVNode(_component_SuggestedDatesPeriodSettings),
                    _hoisted_100
                  ]),
                  _hoisted_101
                ]),
                _hoisted_102
              ]))
            : _createCommentVNode("", true),
          (_ctx.viewType == `complete`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                (_ctx.createPlanType == `changeAstagForOtherPublicRoom`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, " 公開ページ(" + _toDisplayString(_ctx.selectedRoom.public_id) + ")を複製して、調整カレンダーの紐づけが完了しました ", 1),
                      _hoisted_106,
                      (_ctx.Util.isPresent(_ctx.generatedRooms))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatedRooms, (room) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: room.id,
                                class: "hoverLgreyBg rad8 pad10"
                              }, [
                                _createElementVNode("div", _hoisted_108, [
                                  _createElementVNode("p", _hoisted_109, [
                                    _createElementVNode("span", _hoisted_110, "[" + _toDisplayString(room.public_id) + "]", 1),
                                    _createElementVNode("span", _hoisted_111, _toDisplayString(room?.appeal_content?.title || room?.current_appointment?.name), 1)
                                  ]),
                                  (room.current_appointment)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_112, [
                                        _createElementVNode("img", {
                                          src: _ctx.$getAssetImageUrl(`/assets/icons/watch2.png`),
                                          width: "14",
                                          height: "14",
                                          class: "fl mr4 ml2"
                                        }, null, 8, _hoisted_113),
                                        _createTextVNode(" " + _toDisplayString(room.current_appointment.duration) + "分 ", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _hoisted_114,
                                  _createElementVNode("p", {
                                    class: _normalizeClass(`fs14 fw600 skyblue arial fl mt4 mr10 pointer`),
                                    onClick: ($event: any) => (_ctx.copyPageUrl(room.page_url))
                                  }, _toDisplayString(room.page_url), 9, _hoisted_115),
                                  _hoisted_116
                                ]),
                                _hoisted_117
                              ]))
                            }), 128)),
                            _hoisted_118
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_119
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.createPlanType == `copyAstagForOtherPublicRoom`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_120, " 公開ページ(" + _toDisplayString(_ctx.selectedRoom.public_id) + ")を複製同期しました ", 1))
                  : _createCommentVNode("", true),
                _hoisted_121,
                _createElementVNode("button", {
                  type: "submit",
                  class: "pointer centered circle_button skyblueBg fs14 rad8 mr20 mt40",
                  style: {"height":"50px"},
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeModalFromComplete && _ctx.closeModalFromComplete(...args)))
                }, " モーダルを閉じる ")
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeOpen", "onAfterClose"]))
}